// Recovered compiled webpack factory 94681. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "setAttributesFromProps", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let r = {
      acceptCharset: "accept-charset",
      className: "class",
      htmlFor: "for",
      httpEquiv: "http-equiv",
      noModule: "noModule",
    },
    n = [
      "onLoad",
      "onReady",
      "dangerouslySetInnerHTML",
      "children",
      "onError",
      "strategy",
      "stylesheets",
    ];
  function a(e) {
    return ["async", "defer", "noModule"].includes(e);
  }
  function o(e, t) {
    for (let [o, i] of Object.entries(t)) {
      if (!t.hasOwnProperty(o) || n.includes(o) || void 0 === i) continue;
      let s = r[o] || o.toLowerCase();
      ("SCRIPT" === e.tagName && a(s) ? (e[s] = !!i) : e.setAttribute(s, String(i)),
        (!1 === i || ("SCRIPT" === e.tagName && a(s) && (!i || "false" === i))) &&
          (e.setAttribute(s, ""), e.removeAttribute(s)));
    }
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
